import { render, staticRenderFns } from "./trainingsFilter.vue?vue&type=template&id=35147ae6"
import script from "./trainingsFilter.vue?vue&type=script&lang=js"
export * from "./trainingsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports